import { OdataFilters, queryCollection } from "helpers/reqparams";
import { request } from "services/request";

const resource = "api/organizationEmployees";
const logistsQuery = { orderBy: ["id desc"] };

const getItem = (params: { id: number }) => request(`${resource}/getLogist?id=${params.id}`, { method: "GET" });

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...logistsQuery });
    return request(`${resource}/getLogists${query}`, { method: "GET" }, { countInHeaders: true });
};

const list = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...logistsQuery });
    return request(`${resource}/getLogists${query}`, { method: "GET" });
};

export { getItem, index, list };
